import { useEffect } from 'react';
import { useSecurityAudit } from './useSecurityAudit';
import { supabase } from '@/integrations/supabase/client';

/**
 * Hook qui log automatiquement les événements de sécurité importants
 */
export const useSecurityLogger = () => {
  const { logSecurityEvent } = useSecurityAudit();

  useEffect(() => {
    // Logger les erreurs d'authentification
    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN') {
        logSecurityEvent({
          eventType: 'authentication_success',
          eventData: {
            method: session?.user?.app_metadata?.provider || 'email',
            userId: session?.user?.id
          }
        });
      } else if (event === 'SIGNED_OUT') {
        logSecurityEvent({
          eventType: 'logout',
          eventData: {
            userId: session?.user?.id
          }
        });
      } else if (event === 'USER_UPDATED') {
        logSecurityEvent({
          eventType: 'profile_updated',
          eventData: {
            userId: session?.user?.id
          }
        });
      }
    });

    // Intercepter les erreurs globales
    const handleError = (event: ErrorEvent) => {
      if (event.error?.message?.includes('auth') || event.error?.message?.includes('permission')) {
        logSecurityEvent({
          eventType: 'security_error',
          eventData: {
            error: event.error?.message,
            stack: event.error?.stack?.substring(0, 200)
          }
        });
      }
    };

    window.addEventListener('error', handleError);

    return () => {
      authListener?.subscription?.unsubscribe();
      window.removeEventListener('error', handleError);
    };
  }, [logSecurityEvent]);

  // Fonction pour logger manuellement un événement
  const logEvent = (eventType: string, eventData?: Record<string, any>) => {
    logSecurityEvent({ eventType, eventData });
  };

  return { logEvent };
};
